import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";

import { refreshAccessToken } from "@citrine/client";

import { routes } from "./routes";

// refresh on initial page load
if (process.env.NODE_ENV !== "test") {
  refreshAccessToken();
}

// Render the App
window.document.addEventListener("DOMContentLoaded", () => {
  const root =
    window.document.getElementById("citrine-root") ?? window.document.body;
  ReactDOM.createRoot(root).render(
    <RouterProvider router={createBrowserRouter(routes)} />,
  );
});
